module.exports = __webpack_public_path__ + "img/2.fb3ebd4a.png";